import { render, staticRenderFns } from "./ProgramSeriesCard.vue?vue&type=template&id=7078fff2&scoped=true&"
import script from "./ProgramSeriesCard.vue?vue&type=script&lang=js&"
export * from "./ProgramSeriesCard.vue?vue&type=script&lang=js&"
import style0 from "./ProgramSeriesCard.vue?vue&type=style&index=0&id=7078fff2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7078fff2",
  null
  
)

export default component.exports